import { useEffect, useMemo, useState } from 'react';
import { FluidSelect, IOption, ISelectData } from './fluidSelect';

interface IDatePickerCaptionProps {
  from?: Date;
  to?: Date;
  date?: Date;
  onChange: (date: Date) => void;
}

export const DatePickerCaption = (props: IDatePickerCaptionProps) => {
  const date = props.date || new Date();
  const currentYear = new Date().getFullYear();

  const [month, setMonth] = useState(date?.getMonth());
  const [year, setYear] = useState(date?.getFullYear());

  useEffect(() => {
    setMonth(date?.getMonth());
    setYear(date?.getFullYear());
  }, [date]);

  const fromYear = props.from?.getFullYear() ?? currentYear - 5;
  const toYear = props.to?.getFullYear() ?? currentYear + 20;

  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const years = useMemo(() => Array.from({ length: toYear - fromYear + 1 }, (_, i) => fromYear + i), [fromYear, toYear]);

  const handleChange = (data: IOption[]) => {
    const year = data[1]?.value ?? currentYear;
    props.onChange(new Date(+year, month));
  };

  const data = [
    {
      list: months.map((month, idx) => ({ label: month, value: idx })),
      value: month,
      placeholder: 'Month',
      onChange: (value: string | number) => {
        setMonth(+value);
        props.onChange(new Date(year, +value));
      },
    },
    {
      list: years.map((year) => ({ label: year.toString(), value: year })),
      value: year,
      placeholder: 'Year',
      onChange: (value: string | number) => {
        setYear(+value);
        props.onChange(new Date(+value, month));
      },
    },
  ];

  return (
    <div className='DayPicker-Caption'>
      <div className='px-10'>
        <FluidSelect name='month' onSelect={handleChange} data={data as unknown as ISelectData[]} />
      </div>
    </div>
  );
};
